import * as React from "react";
import { action, observable } from "mobx";
import { observer, inject } from "mobx-react";
import SeekerStore from "../../../stores/seekerStore";
import { Language } from "../../../models/profile";
import { LookupValue } from "../../../models/lookup";
import { LookupType } from "../../../models/enums";
import { IEditLangLocalization } from "../../../models/localization";
import { ILocalization } from "../../../models/localization";
import { Grid, Row, Col } from "react-flexbox-grid";
import ResumeNavBtns from "../resumeNavBtns";
import CheckBox from "material-ui/Checkbox";
import Select from "material-ui/Select"
import { MenuItem } from "material-ui/Menu";
import { FormControl, FormControlLabel } from "material-ui/Form";
import * as s from "./lang.css";

@inject("store") @observer
export default class LangEditor extends React.Component<{ store: SeekerStore, fromResume: boolean }, {}> {
  @observable include: boolean;
    constructor(props: any) {
        super(props);
    }
    @action setLanguageId = (lang:Language, id:number): void => {
      lang.langId = id;
      const lookup:LookupValue = this.props.store.localization.getLookup(LookupType.Language).find((lv: LookupValue): boolean => { return lv.order === id });
      lang.lang = lookup ? lookup.value : "";
      if (id !== 0) {
        this.props.store.profileStore.editLanguages.push(new Language());
      }
    }
    addLanguageRow(lang:Language, checked:any): JSX.Element {
        if (this.props.fromResume) {
          return null;
        }
        const items: JSX.Element[] = [];
        this.props.store.localization.getLookup(LookupType.Language).map((lv: LookupValue, i: number): void => {
          const ndx: number = this.props.store.profileStore.profile.languages.findIndex((l: Language): boolean => { return l.langId === lv.order });
          if (ndx !== -1) { return; }
          //if (this.props.store.profileStore.profile.languages.findIndex((l: Language): boolean => { return l.langId === lang.langId }) !== -1) { return; }
          items.push(<MenuItem key={i} value={lv.order}>{lv.value}</MenuItem>);
        });
        return <Row key="add-row">       
          <Col xs={4}>
            <FormControl fullWidth>
              <Select value={lang.langId} onChange={(e:any) => this.setLanguageId(lang, parseInt(e.target.value,10))} inputProps={{ name: "langId", id: "langId" }}>
                {items}
              </Select>
            </FormControl>
          </Col>
          <Col xs={2}>
            <CheckBox checked={(lang.proficiency & 2) > 0} disabled={lang.langId === 0} style={checked} onChange={(e: object, chk: boolean) => this.props.store.profileStore.setProficiency(lang, 2, chk)} />
          </Col>
          <Col xs={2}>
            <CheckBox checked={(lang.proficiency & 4) > 0} disabled={lang.langId === 0} style={checked} onChange={(e: object, chk: boolean) => this.props.store.profileStore.setProficiency(lang, 4, chk)} />
          </Col>
          <Col xs={2}>
            <CheckBox checked={(lang.proficiency & 8) > 0} disabled={lang.langId === 0} style={checked} onChange={(e: object, chk: boolean) => this.props.store.profileStore.setProficiency(lang, 8, chk)} />
          </Col>
          <Col xs={2}>&nbsp;</Col>
        </Row>;
    }
    render(): JSX.Element {
        const checked: any = { color: "#5B6770" };
        const langLocal: IEditLangLocalization = this.props.store.localization.fields.editLangs;
        let langs: Array<Language> = this.props.store.profileStore.setEditLanguages();
        const langRows: JSX.Element[] = [];
        const deleteIcon: string = this.props.store.localization.fields.icons.trash;
        const icon: any = { height: "20px", width: "20px" };
        
        langs.map((l: Language, i: number): void => {
          let incl: boolean = l.langId > 0;
          if (this.props.fromResume) {
            incl = this.props.store.profileStore.languageSelected(l);
          } 
          if (l.langId > 0) {
            langRows.push(
              <Row key={i}>
                <Col xs={4} className={s.addColMargin}>{l.lang}</Col>
                <Col xs={2}>
                  <CheckBox checked={(l.proficiency & 2) > 0} disabled={!incl} style={checked} onChange={(e: object, chk: boolean) => this.props.store.profileStore.setProficiency(l, 2, chk)} />
                </Col>
                <Col xs={2}>
                  <CheckBox checked={(l.proficiency & 4) > 0} disabled={!incl} style={checked} onChange={(e: object, chk: boolean) => this.props.store.profileStore.setProficiency(l, 4, chk)} />
                </Col>
                <Col xs={2}>
                  <CheckBox checked={(l.proficiency & 8) > 0} disabled={!incl} style={checked} onChange={(e: object, chk: boolean) => this.props.store.profileStore.setProficiency(l, 8, chk)} />
                </Col>
                {this.props.fromResume && <Col xs={2}>
                  <CheckBox checked={incl} style={checked} onChange={(e: object, chk: boolean) => this.props.store.profileStore.includeLanguage(l, chk)} />
                </Col>}
                {!this.props.fromResume && <Col xs={2}>
                  <div onClick={() => this.props.store.profileStore.deleteLanguage(l)}><img style={icon} src={deleteIcon} /></div>
                  </Col>}
              </Row>)
          } else {
              langRows.push(this.addLanguageRow(l, checked));
          }          
        });  
        return (
          <div>
            <Row className={s.row}>
              <Col xs={12} md={6} className={s.col}>
                <Row className={s.headers}>                     
                    <Col xs={4}>{langLocal.lang}</Col>
                    <Col xs={2}>{langLocal.read}</Col>
                    <Col xs={2}>{langLocal.write}</Col>
                    <Col xs={2}>{langLocal.speak}</Col>  
                    {this.props.fromResume && <Col xs={2}>{this.props.store.localization.fields.resume.include}</Col>}
                    {!this.props.fromResume && <Col xs={2}>{langLocal.del}</Col>}
                </Row>
                    {langRows}
             </Col>
            </Row>
          {this.props.fromResume && <ResumeNavBtns store={this.props.store} />}
      </div>);
    }
}


// WEBPACK FOOTER //
// ./src/components/profile/langEditor/index.tsx